import {Component, computed, inject, Signal} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {NgIf} from '@angular/common';
import {AlertsComponent} from '../alerts/alerts.component';
import {Notification, NotificationService} from '@uofu-uss/angular-util';

@Component({
    selector: 'app-uss-page-alert',
    standalone: true,
    imports: [
        NgIf,
        AlertsComponent,
    ],
    template: `
      <div *ngIf="hasAlerts()" class="row">
        <div class="">
          <app-uss-alerts (remove)="removeAlertFromAlerts($event)" [alerts]="alerts()" style="width: 100%"></app-uss-alerts>
        </div>
      </div>
    `,
})
export class PageAlertComponent {
    private readonly notificationService = inject(NotificationService);

    public readonly alerts: Signal<ReadonlyArray<Notification>> = toSignal(this.notificationService.observable, {initialValue: []});
    public readonly hasAlerts = computed(() => this.alerts().length > 0);

    removeAlertFromAlerts(notification: Notification) {
        this.notificationService.removeNotification(notification.id);
    }
}
